import React from 'react';

const CircleDot = ({ isPaused, isRecording }) => {
  return <div className={`recording-circle ${isPaused || !isRecording ? 'paused' : ''}`} />;
};

export default CircleDot;
